import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import { CustomIcon } from '~components/index';
import InputLabel from '../InputLabel/InputLabel';
import '../inputs.scss';
import './inputSelects.scss';

interface Props extends CommonInputProps {
  options: SelectData[];
  defaultValue?: SelectData | SelectData[];
  isMulti?: boolean;
  iconName?: IconName;
  isSearchable?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  hookOnChange?: (value: string | number | object | unknown) => void;
  onInputChange?: (value: string) => void;
  onEventChange?: (value: SelectData | SelectData[]) => void;
}

const InputSelect = ({
  name,
  label,
  placeholder,
  iconName,
  labelHelper,
  defaultValue,
  options = [],
  isSearchable = true,
  isMulti = false,
  disabled = false,
  required = false,
  design = 'col-12',
  hookError,
  hookOnChange = () => {},
  onInputChange = () => {},
  onEventChange = () => {},
  onFocus = () => {},
  onBlur = () => {}
}: Props) => {
  const { t } = useTranslation();
  const optionsTranslated = options.map((option: SelectData) => ({
    label: t(option.label),
    value: option.value
  }));
  const debouncedSetValue = debounce((value: string) => {
    onInputChange(value);
  }, 200);

  return (
    <div className={`customInput ${design}`}>
      {label && (
        <InputLabel
          helper={labelHelper}
          name={name}
          text={label}
          required={required}
        />
      )}
      <div
        className={`customInput_container ${
          disabled ? 'customInput_disabled' : ''
        }`}
      >
        {iconName && (
          <CustomIcon
            className="customInput_icon"
            name={iconName}
            color="var(--green-light)"
          />
        )}
        <div className="w-100">
          <Select
            inputId={name}
            isSearchable={isSearchable}
            menuPosition="fixed"
            classNamePrefix="input_select"
            options={optionsTranslated}
            placeholder={t(placeholder!)}
            defaultValue={defaultValue}
            noOptionsMessage={() =>
              t('form_errors.write_to_find_conincedences')
            }
            isMulti={isMulti}
            onChange={(data) => {
              let inputValue;
              if (Array.isArray(data)) {
                inputValue = data
                  .map((item: SelectData) => item.value)
                  .join(',');
                hookOnChange(inputValue);
                onEventChange(data);
              } else {
                const { value } = data as SelectData;
                hookOnChange(value);
                onEventChange(data as SelectData);
              }
            }}
            onInputChange={(value) => {
              value && debouncedSetValue(value);
            }}
            isDisabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </div>
      </div>
      {hookError?.message && (
        <p className="customInput_error">{t(hookError?.message)}</p>
      )}
    </div>
  );
};

export default InputSelect;
